import gql from 'graphql-tag';

export const FRAGMENT_JOB = gql`
  fragment Job on Job {
    id
    status
    result
    step
    processingErrors {
      code
      errorProperties
      message
    }
  }
`;

export const FRAGMENT_JOB_ID = gql`
  fragment JobId on Job {
    id
  }
`;
